import moment from 'moment';

export default class BdaVisits {
  constructor({
    id,
    index,
    shopOwnerName,
    retailerName,
    retailerMobile,
    retailerAddress,
    pinCode,
    storeId,
    storeName,
    shopImage,
    lat,
    long,
    submittedByBda,
    submittedByBdaName,
    createdAt
  }) {
    this.id = id || '';
    this.index = index + 1;
    this.shopOwnerName = shopOwnerName || '';
    this.retailerName = retailerName || '';
    this.retailerMobile = retailerMobile || '';
    this.retailerAddress = retailerAddress || '';
    this.pinCode = pinCode || '';
    this.storeId = storeId || '';
    this.storeName = storeName || '';
    this.shopImage = shopImage || '';
    this.lat = lat || '';
    this.long = long || '';
    this.submittedByBda = submittedByBda || '';
    this.submittedByBdaName = submittedByBdaName || '';
    this.createdAt = moment(createdAt).format('DD-MMM-YYYY');

    this.location = this.lat && this.long ? `https://www.google.com/maps?q=${this.lat},${this.long}` : '';
  }
}
